import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DocumentoService} from '../../services/documento.service';
import {Documento} from '../../models/documento.model';
import {environment} from '../../../../environments/environment';

@Component({
    selector: 'app-relatorio',
    templateUrl: './relatorio.component.html',
    styleUrls: ['./relatorio.component.scss'],
})
export class RelatorioComponent implements OnInit {
    @Input() documento: Documento;
    documentoSelecionado: any = [];
    baseUrl = `${environment.apiUrl}/v1/documento/download`;

    constructor(
        private documentoService: DocumentoService,
    ) {
    }

    ngOnInit() {
    }

    download() {
        const url = `${this.baseUrl}/${this.documento.id}`;
        window.open(url + '.pdf', '_blank');
    }
}
